<template>
  <div class="sb-minibrowser__list-header">
    <slot name="left">
      <SbIcon name="chevron-down" class="sb-minibrowser__list-header-icon" />

      <p class="sb-minibrowser__list-header-title">{{ title }}</p>
    </slot>

    <slot name="right" />
  </div>
</template>

<script lang="ts" setup>
import SbIcon from '../../Icon'

defineProps<{
  /**
   * The title of the minibrowser list
   */
  title: string
}>()
</script>
